import { useState } from "react";
import { addInputsForm } from "../../lib/actions";
import DropDown from "../../components/GDropDownList/DropDown";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AddEmployeesUi({rolesData}) {

    const nav = useNavigate();
    const [roleId, setRoleId] = useState(null)
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    const onchange = (e) => {
        setRoleId(e);
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const result = await addInputsForm(new FormData(e.target), navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3">
                <div className="mb-4">
                    <label className="block text-white  mb-2">{currentLang === "en" ? "name" : "الاسم"}</label>
                    <input
                        type="text"
                        name="name"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 rounded-lg text-white"
                        required
                        placeholder={currentLang === "en" ? "enter name" : "أدخل الاسم"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white  mb-2"> {currentLang === "en" ? "email" : "الايميل"} </label>
                    <input
                        type="text"
                        name="email"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 rounded-lg text-white"
                        required
                        placeholder= {currentLang === "en" ? "enter email" : "أدخل الايميل"} 
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white  mb-2"> {currentLang === "en" ? "password" : "الايميل"} </label>
                    <input
                        type="password"
                        name="password"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 rounded-lg text-white"
                        required
                        placeholder= {currentLang === "en" ? "enter password" : "أدخل كلمة السر"} 
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white  mb-2">  {currentLang === "en" ? "password confirm" : "تاكيد كلمة المرور "} </label>
                    <input
                        type="password"
                        name="password_confirmation"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 rounded-lg text-white"
                        required
                        placeholder= {currentLang === "en" ? "enter password confirm" : "أدخل تاكيد كلمة السر"} 
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "role" : "الدور"}</label>
                    <DropDown defaultText= {currentLang === "en" ? "choose role" : "اختر الدور"} value={roleId} options={rolesData} paramkey={"role_id"} onchange={onchange} />
                </div>
            </div>
            <div className="flex justify-center w-full mt-5">
                <button
                    type="submit"
                    disabled={loading}
                    className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary"
                        }`}
                >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};